import React, { useState } from 'react';
import { Gift } from 'lucide-react';

const PromotionalOffers = ({ productDetails }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Safely handle undefined `productDetails` or `discounts`
  const discounts = productDetails?.discounts || [];

  if(discounts.length === 0) {
    return null;
    }

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative flex items-center bg-red-600 hover:bg-red-700 text-white p-3 rounded-l-lg shadow-lg transition-all duration-300"
      >
        <Gift className="w-6 h-6" />
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-green-500 rounded-full animate-ping" />
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-green-500 rounded-full" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-0 w-64 bg-white p-4 rounded-l-lg shadow-xl border-2 border-red-600 transform translate-y-[-50%]">
          <div className="relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute -top-2 -right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <h3 className="text-lg font-bold text-red-600 mb-3">Special Offers! 🎄</h3>
            <ul
              className="space-y-2 max-h-[300px] overflow-y-auto pr-2"
              style={{
                maxHeight: '300px', // Adjust based on your row height (e.g., 10 rows of ~30px each)
                overflowY: 'auto',
              }}
            >
              {discounts.length > 0 ? (
                discounts.map((discount) => (
                  <li key={discount._id} className="flex items-start space-x-2">
                    <span className="text-red-500">🎁</span>
                    <span>
                      Buy {discount.buyX}, get {discount.discountOnNext}% off on the next {discount.maxApplications} Item.
                    </span>
                  </li>
                ))
              ) : (
                <li>No offers available at the moment for this Category.</li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromotionalOffers;
